import axios from 'axios';
import { AJAX_URL } from '../../../config/index.js';

const errorHighlighting = (field) => {
  let fieldEl = document.getElementsByName(`${field.field}`)[0];

  switch (fieldEl.type) {
    case 'radio':
      fieldEl = fieldEl.parentElement.parentElement.parentElement;
      break;
    case 'select-one':
      fieldEl = fieldEl.parentElement.parentElement;
      break;
    case 'checkbox':
      fieldEl = fieldEl.parentElement.parentElement.parentElement;
      break;
    default:
      fieldEl = fieldEl.parentElement;
      break;
  }

  const classList = fieldEl.classList;
  field.error
    ? classList?.add('form__field--error')
    : classList?.remove('form__field--error');
};

const getMemberLevel = (points) => {
  let level = 0;
  if (points >= 50 && points < 75) {
    level = 1;
  } else if (points >= 75 && points < 100) {
    level = 2;
  } else if (points >= 100 && points < 150) {
    level = 3;
  } else if (points >= 150 && points < 200) {
    level = 4;
  } else if (points >= 200 && points < 350) {
    level = 5;
  } else if (points >= 350 && points < 500) {
    level = 6;
  } else if (points >= 500 && points < 640) {
    level = 7;
  } else if (points >= 640 && points < 800) {
    level = 8;
  } else if (points >= 800 && points < 950) {
    level = 9;
  } else if (points >= 950) {
    level = 10;
  }
  return level;
};

const getAccountBadges = (callback) => {
  axios
    .get(`${AJAX_URL}wl_get_user_badges`)
    .then((response) => callback(response))
    .catch((err) => console.log(err.message));
};

const getAccountDetails = (callback) => {
  axios
    .get(`${AJAX_URL}wl_get_account_details`)
    .then((response) => callback(response))
    .catch((err) => console.log(err.message));
};

const getAccountPoints = (currentYearOnly, callback) => {
  axios
    .post(`${AJAX_URL}wl_get_user_points`, { currentYearOnly: currentYearOnly })
    .then((response) => callback(response))
    .catch((err) => console.log(err.message));
};

const getAccountEvents = (currentYearOnly, callback) => {
  axios
    .post(`${AJAX_URL}wl_get_user_events`, { currentYearOnly: currentYearOnly })
    .then((response) => callback(response))
    .catch((err) => console.log(err.message));
};

const getAccountWebinars = (callback) => {
  axios
    .get(`${AJAX_URL}wl_get_user_webinars`)
    .then((response) => callback(response))
    .catch((err) => console.log(err.message));
};

const getKidDetails = (currentYearOnly, callback) => {
  axios
    .post(`${AJAX_URL}wl_get_kid_details`, { currentYearOnly: currentYearOnly })
    .then((response) => callback(response))
    .catch((err) => console.log(err.message));
};

const getDashboardAnnouncements = (callback) => {
  axios
    .get(`${AJAX_URL}wl_get_dashboard_announcements`)
    .then((response) => callback(response))
    .catch((err) => console.log(err.message));
};

const mostRecentMemberSpotlight = (callback) => {
  axios
    .get(`${AJAX_URL}wl_get_member_spotlight`)
    .then((response) => callback(response))
    .catch((err) => console.log(err.message));
};

const getDashboardNewEvents = (callback) => {
  axios
    .get(`${AJAX_URL}wl_get_dashboard_new_events`)
    .then((response) => callback(response))
    .catch((err) => console.log(err.message));
};

const cancelParticipation = (participationId, callback) => {
  axios
    .post(`${AJAX_URL}wl_cancel_member_participation`, {
      participationId
    })
    .then((response) => callback(response))
    .catch((err) => console.log(err.message));
};

export {
  errorHighlighting,
  getMemberLevel,
  getAccountBadges,
  getAccountDetails,
  getAccountPoints,
  getAccountEvents,
  getAccountWebinars,
  getKidDetails,
  getDashboardAnnouncements,
  mostRecentMemberSpotlight,
  getDashboardNewEvents,
  cancelParticipation
};
